import { render, staticRenderFns } from "./VestBag.vue?vue&type=template&id=0df1f21d&scoped=true"
import script from "./VestBag.vue?vue&type=script&lang=js"
export * from "./VestBag.vue?vue&type=script&lang=js"
import style0 from "./VestBag.vue?vue&type=style&index=0&id=0df1f21d&prod&scoped=true&lang=scss"
import style1 from "./VestBag.vue?vue&type=style&index=1&id=0df1f21d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df1f21d",
  null
  
)

export default component.exports